import type { Action } from 'redux';

export const CLEAR_COST_FILE_TEMPLATE_MAP = 'CLEAR_COST_FILE_TEMPLATE_MAP' as const;

export const clearCostFileTemplateMap = () => ({ type: CLEAR_COST_FILE_TEMPLATE_MAP });

export type ClearCostFileTemplateMapAction = Action<typeof CLEAR_COST_FILE_TEMPLATE_MAP>;
